var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33526928,0.5 C10.1217412,0.5 10.8511329,0.910653491 11.2611698,1.58665469 L17.6197622,12.2020127 C18.0195403,12.8943373 18.0219273,13.746803 17.6260323,14.4413554 C17.2301374,15.1359079 16.4954237,15.5682262 15.6877693,15.577058 L2.97452638,15.577058 C2.1751149,15.5682262 1.44040113,15.1359079 1.04450622,14.4413554 C0.648611309,13.746803 0.650998215,12.8943373 1.05686871,12.1916547 L7.40936871,1.58665469 C7.81940565,0.910653491 8.54879733,0.5 9.33526928,0.5 Z M9.33526928,2 C9.07368676,2 8.83104766,2.1362849 8.69491514,2.3595559 L2.34976218,12.9521033 C2.21650279,13.1828782 2.21570715,13.4670334 2.34767212,13.6985509 C2.47963709,13.9300684 2.72454169,14.0741745 2.98276928,14.0771033 L15.6795264,14.0771033 C15.9459969,14.0741745 16.1909015,13.9300684 16.3228664,13.6985509 C16.4548314,13.4670334 16.4540358,13.1828782 16.3268687,12.9624613 L9.97651928,2.361029 C9.84055716,2.1368845 9.5974266,2 9.33526928,2 Z M8.8049392,10.5467279 C9.09783241,10.2538347 9.57270615,10.2538347 9.86559937,10.5467279 C10.1584926,10.8396211 10.1584926,11.3144949 9.86559937,11.6073881 C9.57270615,11.9002813 9.09783241,11.9002813 8.8049392,11.6073881 C8.51204598,11.3144949 8.51204598,10.8396211 8.8049392,10.5467279 Z M9.33526928,5.077058 C9.74948284,5.077058 10.0852693,5.41284444 10.0852693,5.827058 L10.0852693,8.827058 C10.0852693,9.24127157 9.74948284,9.577058 9.33526928,9.577058 C8.92105572,9.577058 8.58526928,9.24127157 8.58526928,8.827058 L8.58526928,5.827058 C8.58526928,5.41284444 8.92105572,5.077058 9.33526928,5.077058 Z",
    id: "alert",
    fill: "#E94B32",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.19bfcfee42f2143b0abf6ba2bf31d764.svg";
export { ForwardRef as ReactComponent };